import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApiConfig {
  
  //public url = "http://localhost:9996"
  public url = "https://wsmp.medplus.com.co/covid"
}